import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return (
    <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-md p-3">
      <AlertCircle className="w-5 h-5 text-red-600" />
      <span className="text-red-700 text-sm">{error}</span>
    </div>
  );
};

export default ErrorDisplay;
